import z from "zod";

const ConvertEnum = z.enum([
  "gGold_to_profit",
  "profit_to_gGold",
  "balance_to_gGold",
]);
export type ConvertType = z.infer<typeof ConvertEnum>
export default ConvertEnum
